// extracted by mini-css-extract-plugin
export default {"hoverImg":"CardPortfolioHome_hoverImg__ivK4h","hoverTxt":"CardPortfolioHome_hoverTxt__8e9u8"};